var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoogleLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.8055 10.0417H21V10.0002H12V14.0002H17.6515C16.827 16.3287 14.6115 18.0002 12 18.0002C8.6865 18.0002 6 15.3137 6 12.0002C6 8.68674 8.6865 6.00024 12 6.00024C13.5295 6.00024 14.921 6.57724 15.9805 7.51974L18.809 4.69124C17.023 3.02674 14.634 2.00024 12 2.00024C6.4775 2.00024 2 6.47774 2 12.0002C2 17.5227 6.4775 22.0002 12 22.0002C17.5225 22.0002 22 17.5227 22 12.0002C22 11.3297 21.931 10.6752 21.8055 10.0417Z",
    fill: "#FFC107"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.15308 7.34574L6.43858 9.75524C7.32758 7.55424 9.48058 6.00024 12.0001 6.00024C13.5296 6.00024 14.9211 6.57724 15.9806 7.51974L18.8091 4.69124C17.0231 3.02674 14.6341 2.00024 12.0001 2.00024C8.15908 2.00024 4.82808 4.16874 3.15308 7.34574Z",
    fill: "#FF3D00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9999 21.9996C14.5829 21.9996 16.9299 21.0111 18.7044 19.4036L15.6094 16.7846C14.5717 17.5738 13.3036 18.0006 11.9999 17.9996C9.39891 17.9996 7.19041 16.3411 6.35841 14.0266L3.09741 16.5391C4.75241 19.7776 8.11341 21.9996 11.9999 21.9996Z",
    fill: "#4CAF50"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8055 10.0413H21V9.99976H12V13.9998H17.6515C17.2571 15.108 16.5467 16.0763 15.608 16.7853L15.6095 16.7843L18.7045 19.4033C18.4855 19.6023 22 16.9998 22 11.9998C22 11.3293 21.931 10.6748 21.8055 10.0413Z",
    fill: "#1976D2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleLogo);
export default __webpack_public_path__ + "static/media/googleLogo.5d2ece44fd1c0be9c3c04cfd9123b700.svg";
export { ForwardRef as ReactComponent };